"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@heroui/button";
import { HeartIcon } from "@/public/icons/HeartIcon";
import { toggleCompanyLike } from "@/src/app/hooks/companies.hooks";
import { Heart } from "lucide-react";

export default function CompanyLikeButton({
  isLiked,
  ticker,
  token,
  companyId,
}) {
  const [like, setLike] = useState(isLiked);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleToggleLike = async () => {
    setIsDisabled(true);
    try {
      let response;

      if (ticker !== "") {
        response = await toggleCompanyLike(token, ticker);
      } else {
        response = await toggleCompanyLike(token, "", companyId);
      }

      if (response.status === 200) {
        setLike(response.data.data.liked);
      }
    } catch (error) {
      setLike(false);
    }
    setIsDisabled(false);
  };

  useEffect(() => {
    setLike(isLiked);
  }, [isLiked]);

  const buttonStyle = `inline-flex items-center px-4 py-2 border shadow-sm  font-medium focus:outline-none transition ease-in-out duration-150 ${
    like
      ? "bg-1B51CA text-white border-1B51CA"
      : "text-1B51CA bg-FAFAFA hover:bg-blue-50"
  }`;

  return (
    <Button
      size="sm"
      aria-label={like ? "Liked" : "Like"}
      className={buttonStyle}
      onClick={handleToggleLike}
      disabled={isDisabled}
    >
      <Heart
        strokeWidth={1.5}
        absoluteStrokeWidth
        filled={like.toString()}
        fill={like ? "red" : "white"}
        size={20}
      />
      {like ? "Liked" : "Like"}
    </Button>
  );
}
